import PropTypes from 'prop-types';

// material-ui
import { styled } from '@mui/material/styles';
import { shouldForwardProp } from '@mui/system';

import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

const ResultStyle = styled(List, { shouldForwardProp })(() => ({
  background: '#fff',
}));

const ResultItemStyle = styled(ListItemButton, { shouldForwardProp })(({ theme }) => ({
  borderBottom: `1px dashed ${theme.palette.grey[300]}`,
  color: theme.palette.text.primary,
  '&:last-child': {
    borderBottom: 0,
  },
}));

export const Results = ({ searchResults, onSelectResult }) => {
  return (
    <ResultStyle
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      {searchResults?.length ? (
        searchResults.map((item) => (
          <ResultItemStyle
            key={item.id}
            onMouseDown={() => {
              onSelectResult(item);
            }}
          >
            <ListItemIcon>
              <HomeOutlinedIcon sx={{ fontSize: 20 }} />
            </ListItemIcon>
            <ListItemText primary={item.name} />
          </ResultItemStyle>
        ))
      ) : (
        <ResultItemStyle disabled>
          <ListItemIcon>
            <HomeOutlinedIcon sx={{ fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText primary="No Properties found" />
        </ResultItemStyle>
      )}
    </ResultStyle>
  );
};

Results.propTypes = {
  searchResults: PropTypes.array,
  onSelectResult: PropTypes.func,
};
